import { render, staticRenderFns } from "./ServiceOrderHistoryItemComponent.vue?vue&type=template&id=3c972061&"
import script from "./ServiceOrderHistoryItemComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderHistoryItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports